const SHOPIFY_STOREFRONT_TOKEN = process.env.REACT_APP_SHOPIFY_STOREFRONT_TOKEN;
const SHOPIFY_STORE_URL = 'https://ec654b-67.myshopify.com'; // Replace with your store URL
const SHOPIFY_API_VERSION = '2025-01'; // Current API version

export const shopifyService = {
  async getCollectionDetails(handle) {
    try {
      const query = `
        query getCollectionByHandle($handle: String!) {
          collection(handle: $handle) {
            id
            title
            description
            handle
            image {
              url
              altText
              width
              height
            }
            products(first: 20) {
              edges {
                node {
                  id
                  title
                  handle
                  description
                  descriptionHtml
                  productType
                  vendor
                  tags
                  images(first: 10) {
                    edges {
                      node {
                        id
                        url
                        altText
                        width
                        height
                      }
                    }
                  }
                  variants(first: 20) {
                    edges {
                      node {
                        id
                        title
                        price {
                          amount
                          currencyCode
                        }
                        compareAtPrice {
                          amount
                          currencyCode
                        }
                        selectedOptions {
                          name
                          value
                        }
                        quantityAvailable
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;

      // Direct call to Shopify Storefront API
      const response = await fetch(
        `${SHOPIFY_STORE_URL}/api/${SHOPIFY_API_VERSION}/graphql.json`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT_TOKEN,
          },
          body: JSON.stringify({
            query,
            variables: { handle }
          }),
        }
      );

      const data = await response.json();
      
      if (data.errors) {
        throw new Error(data.errors[0].message || 'Failed to fetch collection details');
      }

      // Transform the data to match the expected format
      if (data.data?.collection) {
        const collection = data.data.collection;
        return {
          data: {
            collection: {
              ...collection,
              products: collection.products.edges.map(edge => ({
                id: edge.node.id,
                title: edge.node.title,
                handle: edge.node.handle,
                description: edge.node.description,
                description_html: edge.node.descriptionHtml,
                product_type: edge.node.productType,
                vendor: edge.node.vendor,
                tags: edge.node.tags,
                images: edge.node.images.edges.map(img => ({
                  id: img.node.id,
                  url: img.node.url,
                  alt_text: img.node.altText,
                  width: img.node.width,
                  height: img.node.height
                })),
                variants: edge.node.variants.edges.map(variant => ({
                  id: variant.node.id,
                  title: variant.node.title,
                  price: variant.node.price.amount,
                  compare_at_price: variant.node.compareAtPrice?.amount,
                  selected_options: variant.node.selectedOptions,
                  inventory_quantity: variant.node.quantityAvailable
                }))
              }))
            }
          }
        };
      }

      return data;
    } catch (error) {
      console.error('Shopify API Error:', error);
      throw new Error('Failed to fetch collection details. Please try again later.');
    }
  }
}; 